import React from 'react'
import styled from 'styled-components'
import Simulator from 'components/molecules/Simulator'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import Colors from 'frontend_core/dist/styles/colors'
// import Icon from 'components/atoms/FaIcon'
import Icon from 'components/atoms/Icon'
import Button from 'components/atoms/Button'
import { Checkbox } from 'antd'
import HelpTooltip from 'components/molecules/HelpTooltip'
import SimpleSlider from 'components/molecules/SimpleSlider'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { Input } from 'antd'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

const Contents = styled.div`
  max-width: 1100px;
  margin: auto;
`
const HostLpWrapper = styled.div`
  padding-top: 56px;
  ${mediaMin.phone`
    padding-top: 72px;
    overflow: hidden;
  `};
`
const OHostLpHeader = styled.header`
  position: absolute;
  z-index: 5;
  top: 72px;
  left: 16px;
  ${mediaMin.phone`
    top: 88px;
  `} ${mediaMin.desktop`
    left: calc((100vw - 912px)/2);
  `};
`
const ALogo = styled.p`
  width: 34px;
  height: 34px;
  background: url(${(props) => props.imageLogoMarkUrl}) no-repeat;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  ${mediaMin.phone`
    background: url(${(props) => props.imageLogoUrl}) no-repeat;
    width: 180px;
    height: 34px;
  `};
`
const ALogoLink = styled.a`
  height: 34px;
  display: block;
`
const OFirstView = styled.div`
  background-image: url(${(props) => props.imageSpUrl});
  background-repeat: no-repeat;
  background-position: 30% 70%;
  background-color: ${Colors.grayF};
  background-size: cover;
  height: 332px;
  position: relative;
  overflow: hidden;
  padding: 0 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: 0;
    width: 120%;
    margin: -5% -10% 0;
    height: 110px;
    background: ${Colors.grayF};
    transform-origin: left center;
    transform: rotate(-6deg);
    z-index: 0;
  }

  ${mediaMax.xs`
    background-position: 0 -15px;
  `} ${mediaMin.phone`
    background-image: url(${(props) => props.imagePcUrl});
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 490px;
    background-color: ${Colors.white};
    padding: 0 24px;
    &::after {
      bottom: -15vh;
      background-color: ${Colors.white};
      transform: rotate(-3deg);
    }
  `};
`
const CatchCopyWrap = styled.div`
  position: relative;
`
const MCatchCopy = styled.div`
  position: absolute;
  top: 70px;
  left: 0;
  margin: 0;
  ${mediaMin.phone`
    top: 86px;
    text-align: left;
  `} ${mediaMin.desktop`
    left: calc((100vw - 960px)/2);
  `};
`
const APageTitle = styled.h1`
  font-size: 24px;
  color: $black;
  line-height: 1.3;
  font-weight: bold;
  ${mediaMin.phone`
    font-size: 32px;
  `};
`
const FirstViewTextWrap = styled.div`
  display: block;
  width: 320px;
  margin: 8px 0;
  ${mediaMax.xs`
    width: 100%;
    .a-text{
      font-size: 14px;
    }
  `} ${mediaMin.phone`
    width: 370px;
    margin: 8px 0;
  `};
`
const OSimulator = styled.div`
  position: relative;
  padding: 16px 16px 32px;
  background: ${Colors.grayF};
  ${mediaMin.phone`
    padding: 0;
  `};
`
const OFixBar = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
  background: ${Colors.grayF};
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
`
const OPoints = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
  `};
`
const ASectionTitle = styled.h2`
  font-weight: bold;
  font-size: 22px;
  text-align: center;
  letter-spacing: 1px;
  line-height: 1.2;
  color: ${Colors.black};
  ${mediaMin.phone`
    font-size: 24px;
  `};
`
const ASectionTitleBr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`
const PointsWrap = styled.ol`
  margin-top: 24px;
  padding: 0 16px;
`
const MPoints = styled.li`
  margin-top: 16px;
  position: relative;
  ${mediaMin.phone`
    width: calc((100% - 48px) / 3);
    display: inline-block;
    vertical-align: top;
    margin-right: 24px;
    &:last-child{
      margin-right: 0;
    }
  `};
`
const APointsTitle = styled.h3`
  color: ${Colors.black};
  line-height: 1.3;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  align-items: center;
`
const APointsNum = styled.span`
  font-family: Arial, 'ＭＳ Ｐゴシック', sans-serif;
  font-size: 32px;
  font-weight: bold;
  padding-right: 8px;
  color: ${Colors.green};
`
const PointsTextWrap = styled.div`
  margin-top: 8px;
`
const PointsImageWrap = styled.p`
  max-width: 480px;
  margin: 0 auto;
  img {
    width: 100%;
    height: auto;
    ${mediaMin.phone`
      width: 95%;
    `};
  }
`
const OhostVoice = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  background: ${Colors.lightgreen};
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
  `};
`
const CarouselWrap = styled.div`
  margin: 32px 0 0;
  padding: 0 16px;
`
const MFixBar = styled.div`
  padding: 16px;
  ${mediaMax.xs`
    padding: 8px;
  `} &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const FixBarWrap = styled.div`
  float: right;
  display: inline-flex;
  align-items: center;
`
const FixBarWrapAEstimate = styled.div`
  display: inline-block;
  font-size: 13px;
  padding-top: 12px;
  padding-top: 0;
  ${mediaMax.xs`
    font-size: 12px;
  `} ${mediaMin.phone`
    font-size: 14px;
  `};
`
const FixBarWrapAAmount = styled.div`
  display: inline-block;
  font-family: Arial, 'ＭＳ Ｐゴシック', sans-serif;
  color: ${Colors.black};
  font-weight: bold;
  text-align: right;
  float: none;
  font-size: 20px;
  margin-left: 8px;
  ${mediaMin.phone`
    font-size: 28px;
  `};
`
const FixBarButtonWrap = styled.div`
  display: inline-block;
  margin-top: 0;
  margin-left: 8px;
`
const OSteps = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
  `};
`
const StepsWrap = styled.ol`
  margin: 32px auto 0;
  padding-left: 16px;
  padding-right: 16px;
  max-width: 430px;
  ${mediaMin.phone`
    max-width: 100%;
  `};
`
const MSteps = styled.li`
  position: relative;

  &:nth-child(2) {
    .steps__content {
      padding-top: 24px;
      margin-top: -24px;
    }
  }

  ${mediaMin.phone`
    margin-right: 16px;
    position: relative;
    width: calc((100% - 35px) / 3);
    display: inline-block;
    vertical-align: top;
    &:last-child {
      margin-right: 0;
    }
  `} &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const AStepsTitleNum = styled.span`
  float: left;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  font-weight: bold;
  background: ${Colors.green};
  color: ${Colors.white};
  text-align: center;

  &::after {
    display: none;
  }

  ${mediaMax.phone`
    &::after {
    content: '';
    display: block;
    border-left: 2px dotted ${Colors.green};
    max-height: 350px;
    height: 95%;
    position: absolute;
    top: 18px;
    left: 18px;
    z-index: -1;
    }
  `} ${mediaMin.phone`
    display: block;
    float: none;
    position: relative;
    margin: auto;
    &::after {
      content: '';
      display: block;
      border-top: 2px dotted ${Colors.green};
      max-width: 350px;
      width: 30vw;
      position: absolute;
      top: 16px;
      left: 0;
      margin-left: 35px;
      z-index: -1;
    }
  `};
`
const AStepsTitleNumLast = styled.span`
  float: left;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  font-weight: bold;
  background: ${Colors.green};
  color: ${Colors.white};
  text-align: center;
  ${mediaMin.phone`
    display: block;
    float: none;
    position: relative;
    margin: auto;
  `} &::after {
    display: none;
  }
`
const AStepsTitle = styled.h3`
  color: ${Colors.black};
  line-height: 1.3;
  font-weight: bold;
  float: left;
  ${mediaMin.phone`
    float: none;
    margin-top: 8px;
  `} font-size: 18px;
  padding: 5px 0 5px 8px;
  ${mediaMin.phone`
    text-align: center;
  `};
`
const AStepsTitleBr = styled.br`
  display: none;
  ${mediaMax.xs`
    display: inline;
  `};
`
const OPriceList = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  background: ${Colors.grayF};
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
    padding-left: 16px;
    padding-right: 16px;
  `};
`
const APriceListText = styled.span`
  font-size: 14px;
  font-weight: normal;
  float: right;
  padding-top: 2px;
`
const OMediaList = styled.div`
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
  `};
`
const MediaListWrap = styled.div`
  text-align: center;
`
const MMediaList = styled.ul`
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 890px;
  margin: 24px auto;
  padding: 0 24px;
  text-align: center;
`
const StepsContent = styled.div`
  float: right;
  width: 90%;
  padding-bottom: 16px;
  ${mediaMin.phone`
    float: none;
    width: 100%;
    padding-left: 0;
    border-left: none;
  `} ${mediaMax.xs`
    width: 257px;
  `};
`
const StepsContent2 = styled.div`
  float: right;
  width: 90%;
  padding-bottom: 16px;
  ${mediaMin.phone`
    float: none;
    width: 100%;
    padding-left: 0;
    border-left: none;
  `} ${mediaMax.xs`
    width: 257px;
    padding-top: 24px;
    margin-top: -24px;
  `};
`
const StepsTextWrap = styled.div`
  ${mediaMin.phone`
    margin-top: 8px;
  `};
`
const StepsImageWrap = styled.p`
  margin-top: 8px;
  img {
    width: 95%;
    height: auto;
  }
`
const MTitleLeadAText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  padding: 0 16px;
  margin-top: 16px;
  ${mediaMin.phone`
    width: 600px;
    margin:	16px auto;
    text-align: center;
  `};
`
const MPriceList = styled.div`
  padding: 16px;
  background: ${Colors.white};
  border-radius: 5px;
  width: calc(100% - 32px);
  margin: 16px auto;
  ${mediaMin.phone`
    width: auto;
    display: flex;
    justify-content: center;
  `} @media screen and (max-width: 832px) {
    display: block;
  }

  &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const APriceList = styled.dl`
  font-size: 16px;
  font-weight: bold;
  padding: 6px 0;
  display: inline-flex;
  flex-wrap: wrap;
  ${mediaMax.xs`
    flex-shrink: 0;
  `} ${mediaMin.phone`
    &:nth-child(2) {
      margin: 0 20px;
    }
  `}

  @media screen and (max-width: 832px) {
    display: flex;
    justify-content: center;
  }
  .fa {
    font-size: 16px;
  }
`
const OHostForm = styled.div`
  background: ${Colors.lightgreen};
  position: relative;
  padding-top: 32px;
  padding-bottom: 24px;
  ${mediaMin.phone`
    padding-top: 40px;
    padding-bottom: 32px;
  `};
`
const MFostForm = styled.div`
  margin: 24px auto;
  background: ${Colors.white};
  border-radius: 3px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  padding: 24px 16px;
  width: calc(100% - 32px);
  ${mediaMin.phone`
    max-width: 650px;
    padding: 24px 32px;
  `};
`
const HostFormSectionClearfix = styled.div`
  margin-top: 16px;
  width: 100%;

  &::after {
    content: '';
    clear: both;
    display: block;
  }
`
const HostFormSection = styled.div`
  margin-top: 16px;
  width: 100%;
`
const AFormTitle = styled.span`
  font-size: 13px;
  display: block;
  color: ${Colors.gray9};
`
const HostFormNameWrap = styled.div`
  width: calc(50% - 4px);
  margin-top: 8px;
  margin-right: 8px;
  float: left;

  &:last-child {
    margin-right: 0;
  }
  input {
    height: 40px;
  }
`
const HostFormWrap = styled.div`
  margin-top: 8px;
  input {
    height: 40px;
  }
`
const HostFormCheckWarp = styled.label`
  display: block;
  margin-top: 16px;
`
const HostFormTermsWrap = styled.div`
  margin-top: 16px;
`
const AHostFormCheck = styled.input`
  display: none;
`
const HostFormButtonWrap = styled.div`
  margin-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${Colors.grayD};

  & > div {
    display: block;
  }
`
const HostFormTextWrap = styled.div`
  text-align: center;
  margin-top: 16px;
`
const HostFormTextWrapATextBr = styled.br`
  display: none;
  ${mediaMax.xs`
    display: inline;
  `};
`
const TitleLeadAText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  padding: 0 16px;
  margin-top: 16px;
  ${mediaMin.phone`
    width: 680px;
    margin:	16px auto;
    text-align: center;
  `};
`
const AText = styled.p`
  font-size: 16px;
  line-height: 1.6;
`
const ATextLink = styled.a`
  color: #0e8a01;
`
const AButtonFb = styled.a`
  display: inline-block;
  position: relative;
  background: #305097;
  color: ${Colors.white};
  border-radius: 3px;
  text-align: center;
  font-weight: bold;
  text-decoration: none;
  border: none;
  line-height: 1;
  cursor: pointer;
  padding: 15px 0;
  font-size: 16px;
  width: 100%;

  &::before {
    position: absolute;
    z-index: 1;
    font-size: 18px;
    left: 20px;
    top: 14px;
    font-weight: normal;
  }

  &:hover {
    text-decoration: none;
  }
`
const AMediaLogo = styled.img`
  display: inline-block;
  height: 40px;
  width: auto;
  margin: 8px;
  ${mediaMin.phone`
    height: 60px;
    margin: 24px;
  `};
`
const Spbr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`

export type PropTypes = {
  prefectureSelectProps: Object,
  prefectureOptionList: Object,
  regionSelectProps: Object,
  regionOptionList: Object,
  capacitySelectProps: Object,
  capacityOptionList: Object,
  price: string,
}

const ErrorMessage = styled.p`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  margin-top: 5px;
  margin-bottom: ${spacing.small_3}px;
  line-height: 1.4;
  i {
    margin-right: 3px;
  }
`

export default class HostEntryPage extends React.Component<*> {
  render() {
    const { account, onSubmit, onChange, onHostRegistrationClick } = this.props

    return (
      <HostLpWrapper className="host-lp">
        <OHostLpHeader>
          <ALogo
            imageLogoMarkUrl={imagePath('service/logo-mark.svg')}
            imageLogoUrl={imagePath('service/logo.svg')}
          >
            <ALogoLink href={wwwUrl('/')}>スペースマーケット</ALogoLink>
          </ALogo>
        </OHostLpHeader>
        <OFirstView
          imagePcUrl={imagePath('service/lp/fv_img_pc.png')}
          imageSpUrl={imagePath('service/lp/fv_img_sp.png')}
        >
          <CatchCopyWrap>
            <MCatchCopy>
              <APageTitle>スペースをかんたんに貸し出し</APageTitle>
              <FirstViewTextWrap>
                <AText>
                  スペースマーケットではお持ちのスペースを1時間単位から貸し出すことができます。
                  <br />
                  ホスト登録して、収益アップをしませんか？
                </AText>
              </FirstViewTextWrap>
            </MCatchCopy>
          </CatchCopyWrap>
        </OFirstView>
        <OSimulator>
          <Contents>
            <Simulator
              prefectureSelectProps={this.props.prefectureSelectProps}
              prefectureOptionList={this.props.prefectureOptionList}
              regionSelectProps={this.props.regionSelectProps}
              regionOptionList={this.props.regionOptionList}
              capacitySelectProps={this.props.capacitySelectProps}
              capacityOptionList={this.props.capacityOptionList}
              price={this.props.price}
              onClick={this.props.onHostRegistrationClick}
            />
          </Contents>
        </OSimulator>
        <OFixBar>
          <Contents>
            <MFixBar>
              <FixBarWrap>
                <FixBarWrapAEstimate>
                  {i18n.t('page.hostEntry.expectedRevenue')}：
                  <HelpTooltip
                    beakHorizontalPosition="78px"
                    beakHorizontalPositionSp="16px"
                    positionType="left"
                    left="0px"
                    text={i18n.t('page.hostEntry.expectedRevenueHint')}
                  >
                    <Icon
                      type="fa fa-question-circle"
                      name="question-circle"
                      positionType="left"
                    />
                  </HelpTooltip>
                </FixBarWrapAEstimate>
                <FixBarWrapAAmount>
                  <Icon className="fa fa-yen" iconSize="26" iconSizeSp="18" />
                  {this.props.price}
                </FixBarWrapAAmount>
                <FixBarButtonWrap>
                  <Button
                    large
                    fontSizeSp="14"
                    fontSizePc="14"
                    colorType="green"
                    buttonWidthPc="180"
                    buttonWidthSp="130"
                    buttonHeightPc="40"
                    buttonHeightSp="40"
                    onClick={onHostRegistrationClick}
                    fontWeight
                  >
                    {i18n.t('page.hostEntry.registOwnerHeader.0')}
                    <Spbr />
                    {i18n.t('page.hostEntry.registOwnerHeader.1')}
                  </Button>
                </FixBarButtonWrap>
              </FixBarWrap>
            </MFixBar>
          </Contents>
        </OFixBar>
        <OPoints>
          <Contents>
            <ASectionTitle>
              スペースマーケットが
              <ASectionTitleBr />
              選ばれる3つの理由
            </ASectionTitle>
            <PointsWrap>
              <MPoints>
                <APointsTitle>
                  <APointsNum>1.</APointsNum>充実のサポート
                </APointsTitle>
                <PointsTextWrap>
                  <AText>
                    ページの作成から集客、運営までのお悩み・ご相談など、スタッフがサポート。定期的に説明会も開催し、スペース運営のノウハウをシェアしています。
                  </AText>
                </PointsTextWrap>
                <PointsImageWrap>
                  <img
                    src={imagePath('service/lp/point_01@3x.png')}
                    alt="ポイント1"
                  />
                </PointsImageWrap>
              </MPoints>
              <MPoints>
                <APointsTitle>
                  <APointsNum>2.</APointsNum>多様な利用シーン
                </APointsTitle>
                <PointsTextWrap>
                  <AText>
                    イベント開催、会議・社員研修などのビジネス利用から結婚式・誕生会などのパーティー利用まで、幅広いシーンに利用されています。
                  </AText>
                </PointsTextWrap>
                <PointsImageWrap>
                  <img
                    src={imagePath('service/lp/point_02@3x.png')}
                    alt="ポイント2"
                  />
                </PointsImageWrap>
              </MPoints>
              <MPoints>
                <APointsTitle>
                  <APointsNum>3.</APointsNum>安心のリスク回避
                </APointsTitle>
                <PointsTextWrap>
                  <AText>
                    信頼できるゲスト予約を選定し、突然のキャンセルを回避します。また、何らかのトラブルが発生した場合、損害額を1億円を限度として補償します。
                  </AText>
                </PointsTextWrap>
                <PointsImageWrap>
                  <img
                    src={imagePath('service/lp/point_03@3x.png')}
                    alt="ポイント3"
                  />
                </PointsImageWrap>
              </MPoints>
            </PointsWrap>
          </Contents>
        </OPoints>
        <OhostVoice>
          <Contents>
            <ASectionTitle>先輩ホストの声</ASectionTitle>
            <CarouselWrap>
              <SimpleSlider />
            </CarouselWrap>
          </Contents>
        </OhostVoice>
        <OSteps>
          <Contents>
            <ASectionTitle>スペース掲載までの流れ</ASectionTitle>
            <StepsWrap>
              <MSteps>
                <AStepsTitleNum>1</AStepsTitleNum>
                <AStepsTitle>ホスト登録</AStepsTitle>
                <StepsContent>
                  <StepsTextWrap>
                    <AText>スペースマーケットへホスト登録して頂きます。</AText>
                  </StepsTextWrap>
                  <StepsImageWrap>
                    <img
                      src={imagePath('service/lp/step_01@3x.png')}
                      alt="ステップ1"
                    />
                  </StepsImageWrap>
                </StepsContent>
              </MSteps>
              <MSteps>
                <AStepsTitleNum>2</AStepsTitleNum>
                <AStepsTitle>
                  ホスト/スペース情報入力
                  <AStepsTitleBr />
                  ・審査
                </AStepsTitle>
                <StepsContent2>
                  <StepsTextWrap>
                    <AText>
                      ホストとスペース詳細情報を入力頂き、審査を行います。審査を行う際は、免許証/パスポート/住基カードのいずれかが必要となります
                    </AText>
                  </StepsTextWrap>
                  <StepsImageWrap>
                    <img
                      src={imagePath('service/lp/step_02@3x.png')}
                      alt="ステップ2"
                    />
                  </StepsImageWrap>
                </StepsContent2>
              </MSteps>
              <MSteps>
                <AStepsTitleNumLast>3</AStepsTitleNumLast>
                <AStepsTitle>スペースの掲載開始！</AStepsTitle>
                <StepsContent>
                  <StepsTextWrap>
                    <AText>
                      審査通過後、いよいよスペースの掲載が始まります。
                    </AText>
                  </StepsTextWrap>
                  <StepsImageWrap>
                    <img
                      src={imagePath('service/lp/step_03@3x.png')}
                      alt="ステップ3"
                    />
                  </StepsImageWrap>
                </StepsContent>
              </MSteps>
            </StepsWrap>
          </Contents>
        </OSteps>
        <OPriceList>
          <Contents>
            <div>
              <ASectionTitle>明快な料金システム</ASectionTitle>
              <TitleLeadAText>
                掲載はもちろん無料！
                <br />
                スペースが利用された場合、下記の利用料金をご登録銀行口座へ振込みさせて頂きます。
              </TitleLeadAText>
            </div>
            <MPriceList>
              <APriceList>
                <dt>
                  <Icon className="far fa-sun a-priceList__icon" />
                  1日レンタル
                </dt>
                <dd>
                  <APriceListText>…成約金額の70%</APriceListText>
                </dd>
              </APriceList>
              <APriceList>
                <dt>
                  <Icon className="far fa-clock a-priceList__icon" />
                  時間レンタル
                </dt>
                <dd>
                  <APriceListText>…成約金額の70%</APriceListText>
                </dd>
              </APriceList>
              <APriceList>
                <dt>
                  <Icon className="far fa-moon a-priceList__icon" />
                  宿泊レンタル
                </dt>
                <dd>
                  <APriceListText>…成約金額の90%</APriceListText>
                </dd>
              </APriceList>
            </MPriceList>
          </Contents>
        </OPriceList>
        <OMediaList>
          <Contents>
            <ASectionTitle>多くのメディアでも紹介！</ASectionTitle>
            <MediaListWrap>
              <MMediaList>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/5331"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/nhk.png')}
                        alt="NHK"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/5381"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/nikkei.png')}
                        alt="日本経済新聞"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/6061"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/fujitv.png')}
                        alt="フジテレビ"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/5621"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/tbs.png')}
                        alt="TBS"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/5621"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/asahi.png')}
                        alt="朝日新聞"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://diamond.jp/articles/-/60963"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/yahoo.png')}
                        alt="Yahoo!ニュース"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/5471"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/yomiuri.png')}
                        alt="YOMIURI ONLINE"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/721"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/jwave.png')}
                        alt="J-WAVE"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/7261"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/reuters.png')}
                        alt="REUTERS"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href="http://spacemarket.co.jp/archives/7351"
                      target="_blank"
                    >
                      <AMediaLogo
                        src={imagePath('service/footer/media/r25.png')}
                        alt="R25"
                      />
                    </a>
                  </div>
                </li>
              </MMediaList>
            </MediaListWrap>
          </Contents>
        </OMediaList>
        {!this.props.currentUser && (
          <OHostForm>
            <div id="applyhost" className="contents">
              <div>
                <ASectionTitle>まずはホスト登録を！</ASectionTitle>
                <MTitleLeadAText>
                  お持ちのスペースを今すぐ有効活用しませんか？
                  <br />
                  様々なスペースが登録できます。
                </MTitleLeadAText>
              </div>
              <MFostForm>
                <HostFormSectionClearfix>
                  <AFormTitle>お名前：</AFormTitle>
                  <HostFormNameWrap>
                    <Input
                      onChange={onChange}
                      placeholder={i18n.t('page.shared.l_00059')}
                      id="family_name"
                      name="familyName"
                      value={account.familyName}
                    />
                    {account.errors && account.errors['users.family_name'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['users.family_name']}
                      </ErrorMessage>
                    )}
                  </HostFormNameWrap>
                  <HostFormNameWrap>
                    <Input
                      onChange={onChange}
                      placeholder={i18n.t('page.shared.l_00060')}
                      name="givenName"
                      value={account.givenName}
                    />
                    {account.errors && account.errors['users.given_name'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['users.given_name']}
                      </ErrorMessage>
                    )}
                  </HostFormNameWrap>
                </HostFormSectionClearfix>
                <HostFormSection>
                  <AFormTitle>{i18n.t('page.shared.l_00046')}</AFormTitle>
                  <HostFormWrap>
                    <Input
                      onChange={onChange}
                      placeholder={i18n.t('page.shared.l_00046')}
                      name="email"
                      type="email"
                      value={account.email}
                    />
                    {account.errors && account.errors['users.email'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['users.email']}
                      </ErrorMessage>
                    )}
                  </HostFormWrap>
                </HostFormSection>
                <HostFormSection>
                  <AFormTitle>{i18n.t('page.shared.l_00047')}</AFormTitle>
                  <HostFormWrap>
                    <Input
                      onChange={onChange}
                      lable={i18n.t('page.shared.l_00047')}
                      placeholder="0312345678"
                      value={account.tel}
                      name="tel"
                    />
                    {account.errors && account.errors['tel'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['tel']}
                      </ErrorMessage>
                    )}
                  </HostFormWrap>
                </HostFormSection>
                <HostFormSection>
                  <AFormTitle>{i18n.t('page.shared.l_00061')}</AFormTitle>
                  <HostFormWrap>
                    <Input
                      onChange={onChange}
                      type="password"
                      value={account.password}
                      name="password"
                      label={i18n.t('page.shared.l_00061')}
                    />
                    {account.errors && account.errors['users.password'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['users.password']}
                      </ErrorMessage>
                    )}
                  </HostFormWrap>
                </HostFormSection>
                <HostFormSection>
                  <AFormTitle>{i18n.t('page.shared.l_00062')}</AFormTitle>
                  <HostFormWrap>
                    <Input
                      onChange={onChange}
                      type="password"
                      value={account.passwordConfirmation}
                      name="passwordConfirmation"
                      label={i18n.t('page.shared.l_00062')}
                    />
                    {account.errors &&
                      account.errors['users.password_confirmation'] && (
                        <ErrorMessage>
                          <Icon className="fa fa-exclamation-circle" />
                          {account.errors['users.password_confirmation']}
                        </ErrorMessage>
                      )}
                  </HostFormWrap>
                </HostFormSection>
                <HostFormTermsWrap>
                  <AText>
                    <ATextLink href={wwwUrl('/about/terms')} target="_blank">
                      {i18n.t('page.shared.l_00005')}
                    </ATextLink>
                    と
                    <ATextLink
                      href={wwwUrl(
                        '/owners/dashboard/about/terms_of_partner_for_new',
                      )}
                      target="_blank"
                    >
                      {i18n.t('page.shared.l_00006')}
                    </ATextLink>
                    をお読みください。
                  </AText>
                </HostFormTermsWrap>
                <HostFormSection>
                  <HostFormCheckWarp>
                    <AHostFormCheck
                      type="checkbox"
                      value={i18n.t('page.account.l_00016')}
                    />
                    <span>
                      <Checkbox
                        id="checkbox-1"
                        onClick={onChange}
                        name="acceptTermOfService"
                        checked={account.acceptTermOfService}
                      >
                        {i18n.t('page.account.l_00016')}
                      </Checkbox>
                    </span>
                    {account.errors &&
                      account.errors['accept_term_of_service'] && (
                        <ErrorMessage>
                          <Icon className="fa fa-exclamation-circle" />
                          {account.errors['accept_term_of_service']}
                        </ErrorMessage>
                      )}
                  </HostFormCheckWarp>
                  <HostFormCheckWarp>
                    <AHostFormCheck
                      type="checkbox"
                      value={i18n.t('page.account.l_00036')}
                    />
                    <span>
                      <Checkbox
                        id="checkbox-2"
                        onClick={onChange}
                        name="acceptTermOfHost"
                        checked={account.acceptTermOfHost}
                      >
                        {i18n.t('page.account.l_00036')}
                      </Checkbox>
                    </span>
                    {account.errors && account.errors['accept_term_of_host'] && (
                      <ErrorMessage>
                        <Icon className="fa fa-exclamation-circle" />
                        {account.errors['accept_term_of_host']}
                      </ErrorMessage>
                    )}
                  </HostFormCheckWarp>
                </HostFormSection>
                <HostFormSection>
                  <HostFormButtonWrap>
                    <Button
                      large
                      fontSizeSp="16"
                      fontSizePc="16"
                      colorType="green"
                      onClick={onSubmit}
                      buttonHeightPc="42"
                      fontWeight
                    >
                      {i18n.t('page.hostEntry.registOwner')}
                    </Button>
                  </HostFormButtonWrap>
                </HostFormSection>
                <HostFormSection>
                  <HostFormTextWrap>
                    <AText>
                      {i18n.t('page.account.l_00037')}
                      <HostFormTextWrapATextBr />
                      <ATextLink href={wwwUrl('/i/login')}>ログイン</ATextLink>
                    </AText>
                  </HostFormTextWrap>
                  <HostFormTextWrap>
                    <AText>
                      <Icon className="fa fa-download a-faDownload" />
                      資料ダウンロードは
                      <ATextLink
                        href="https://d1p70l9icfjben.cloudfront.net/docs/for-host.pdf?v=20230929"
                        target="_blank"
                      >
                        こちら
                      </ATextLink>
                    </AText>
                  </HostFormTextWrap>
                </HostFormSection>
              </MFostForm>
            </div>
          </OHostForm>
        )}
      </HostLpWrapper>
    )
  }
}
